import axios, { AxiosRequestConfig } from 'axios';
import { stringify } from 'qs';

import config from '../Config';

const baseConfiguration: AxiosRequestConfig = {
  timeout: 10000,
  paramsSerializer: { serialize: (params) => stringify(params, { arrayFormat: 'repeat' }) },
  withCredentials: config.credentialsAllowed
};

const API = axios.create({
  ...baseConfiguration,
  baseURL: config.apiUrl || '/api'
});

export const CommonAPI = axios.create({
  ...baseConfiguration,
  baseURL: config.commonApiUrl
});

export default API;
